export function getCurrentScrollOffset() {
  return window.pageYOffset;
}
